import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { defaultChainId } from 'components/DummyData';
import queryString from 'query-string';

const useCurrentChain = (useFallback = false, onlySupportedChains = true) => {
  const location = useLocation();
  const {
    ChainList,
    currentChainId,
    netWorkSupported,
  } = useSelector((state) => state.Trade);

  const fallbackChain = useMemo(() => {
      const fallbackChainId = queryString.parse(location.search).chainId
          ?? localStorage.getItem('lastChainId') ?? defaultChainId;
      return ChainList.find(chain => chain.id == fallbackChainId);
  }, [ChainList, location.search]);

  return useMemo(
    () => ((onlySupportedChains && !netWorkSupported)
        ? null
        : ChainList.find(chain => chain.id === currentChainId))
        ?? (useFallback ? fallbackChain : null),
    [
        ChainList,
        currentChainId,
        useFallback,
        onlySupportedChains,
        netWorkSupported,
        fallbackChain,
    ],
  );
};

export default useCurrentChain;
